import { useNavigate } from "react-router";
import "./homeimage.css";

function HomeImage({ imageName, target = "/" }) {
  const navigate = useNavigate();

  return (
    <div className="home-image-contenair">
      <div
        className="home-image"
        onClick={() => navigate(target)}
        style={{
          backgroundImage: `url(/images/${imageName})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="home-image-filter"></div>
      </div>
    </div>
  );
}

export default HomeImage;
